import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const faqPageK = {
  faqAbbreviation: "faq_page.faqAbbreviation",
  projects: "faq_page.projects",
  profile: "faq_page.profile",
  deliveries: "faq_page.deliveries",
  payment: "faq_page.payment",
  faq: "faq_page.faq",
};

export const useFaqPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      faqAbbreviation: t(faqPageK.faqAbbreviation),
      projects: t(faqPageK.projects),
      profile: t(faqPageK.profile),
      deliveries: t(faqPageK.deliveries),
      payment: t(faqPageK.payment),
      faq: t(faqPageK.faq),
    }),
    [i18n.language]
  );
};